import { render, staticRenderFns } from "./alterPassword.vue?vue&type=template&id=3bb65a1d&"
import script from "./alterPassword.vue?vue&type=script&lang=js&"
export * from "./alterPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/login/alterPassword.vue"
export default component.exports